import React, { useState } from "react"
import { stringifyDate } from "../../modules"

import Modal from "../reusable/modal"
import Patient from "../reusable/patient"

const TypeOfEvent = ({ visible, toggle, event }) => (
    <Modal
        w={ 450 }
        toggle={toggle}
        visible={visible}
        title={event?.title}>
        <div className="flex flex-wrap mt-3 mb-6">
            <p className="text-gray-500 mt-0 text-xs italic">Visits scheduled for {stringifyDate(event?.date, true)}</p>
            {
                event?.patients?.length > 0 ?
                    <table className="table-auto w-full">
                        {/* Table header */}
                        <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                            <tr>
                                <th className="p-2">
                                    <div className="font-semibold text-center">No.</div>
                                </th>
                                <th className="p-2">
                                    <div className="font-semibold text-left">Patient Name</div>
                                </th>
                                <th className="p-2">
                                    <div className="font-semibold text-left">Phone</div>
                                </th>
                                <th className="p-2">
                                    <div className="font-semibold text-left">Location</div>
                                </th>
                            </tr>
                        </thead>
                        {/* Table body */}
                        <tbody className="text-sm font-medium divide-y divide-gray-100">
                            {
                                event?.patients.map(({ patient }, key) =>
                                    <tr>
                                        <td className="p-2">
                                            <div className="text-center">
                                                {key + 1}
                                            </div>
                                        </td>
                                        <td className="p-2">
                                            <Patient patient={patient} />
                                        </td>
                                        <td className="p-2">
                                            <div className="text-left">{patient.phone}</div>
                                        </td>
                                        <td className="p-2">
                                            <div className="text-left">{patient.locality}, {patient.county}</div>
                                        </td>
                                    </tr>
                                )
                            }
                        </tbody>
                    </table>
                    :
                    <div className="w-full h-16 flex items-center justify-center">
                        <p className="font-semibold text-base">No scheduled visits for {stringifyDate(event?.date, true)}</p>
                    </div>
            }
        </div>
        <div className="flex justify-end">
            <button onClick={toggle} className="text-white bg-gray-500 hover:bg-gray-600 focus:ring-4 focus:ring-gray-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center">Close</button>
        </div>
    </Modal>
)

export default TypeOfEvent